import { render } from "./SuscripcionEmpr.vue?vue&type=template&id=5dd6cc98"
import script from "./SuscripcionEmpr.vue?vue&type=script&lang=js"
export * from "./SuscripcionEmpr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__